import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../../main';
import { toast } from 'react-toastify';
import { 
    crearInscripcionCompleta, 
    fetchInscripcionProgreso,
    Progress,
    InscripcionFormData 
} from '../api/inscripcionService';
import { esChoquesCambiados } from './usePlazas';
import { invalidarListasDeCobro } from './invalidaciones';

export const useCrearInscripcionMutation = () => useMutation({
    mutationFn: (data: InscripcionFormData) => crearInscripcionCompleta(data),
    onSuccess: () => {
        // Antes no se refrescaba SEPA: una domiciliación nueva no aparecía
        // en la lista hasta recargar (caché de 5 minutos).
        invalidarListasDeCobro();
        queryClient.invalidateQueries({ queryKey: ['plazas'] });
        toast.success('Inscripción iniciada exitosamente');
    },
    onError: (error: unknown) => {
        // Se llenó alguna clase desde el aviso: no es un error, lo cuenta el aviso al refrescarse.
        if (esChoquesCambiados(error)) return;
        toast.error('Error al realizar la inscripción');
    }
});

export const useInscripcionProgress = (sessionId?: string) => {
    return useQuery<Progress>({
        queryKey: ['inscripcion-progress', sessionId],
        queryFn: () => fetchInscripcionProgreso(sessionId!),
        enabled: !!sessionId,
        refetchInterval: (query) => 
            query.state.data?.status === 'processing' ? 1000 : false,
        staleTime: 0,
    });
};